import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Package, FileText, MessageSquare, Users, ShoppingCart, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ products: 0, blog: 0, contacts: 0, applications: 0, orders: 0 });
  const [recentContacts, setRecentContacts] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/products"),
      api.get("/blog", { params: { published_only: false } }),
      api.get("/contact"),
      api.get("/dealers/applications"),
      api.get("/orders"),
    ]).then(([p, b, c, d, o]) => {
      setStats({ products: p.data.length, blog: b.data.length, contacts: c.data.length, applications: d.data.length, orders: o.data.length });
      setRecentContacts(c.data.slice(0, 5));
      setRecentOrders(o.data.slice(0, 5));
    }).catch(() => {});
  }, []);

  const cards = [
    { label: "Sipariş", count: stats.orders, icon: ShoppingCart, to: "/admin/orders" },
    { label: "Ürün", count: stats.products, icon: Package, to: "/admin/products" },
    { label: "Blog Yazısı", count: stats.blog, icon: FileText, to: "/admin/blog" },
    { label: "Mesaj", count: stats.contacts, icon: MessageSquare, to: "/admin/contacts" },
    { label: "Bayi Başvurusu", count: stats.applications, icon: Users, to: "/admin/dealers" },
  ];

  return (
    <div>
      <div className="wb-overline">Genel Bakış</div>
      <h1 className="wb-h2 mt-2">Yönetici Paneli</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 mt-10">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="wb-card p-6 group" data-testid={`stat-${c.label}`}>
            <div className="flex items-center justify-between">
              <c.icon className="text-[#d4af37]" size={22} />
              <ArrowRight size={16} className="text-[#a0aabf] group-hover:text-[#d4af37] group-hover:translate-x-1 transition-all" />
            </div>
            <div className="font-serif text-4xl mt-5">{c.count}</div>
            <div className="text-xs uppercase tracking-widest text-[#a0aabf] mt-2">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12">
        <div>
          <div className="flex items-center justify-between">
            <h2 className="wb-h3">Son Siparişler</h2>
            <Link to="/admin/orders" className="text-xs uppercase tracking-widest text-[#d4af37]">Tümü</Link>
          </div>
          <div className="mt-5 wb-card">
            {recentOrders.length === 0 ? (
              <div className="p-8 text-center text-sm text-[#a0aabf]">Henüz sipariş yok.</div>
            ) : (
              <ul className="divide-y divide-white/5">
                {recentOrders.map((o) => (
                  <li key={o.id} className="p-5 flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <div className="font-mono text-xs text-[#d4af37]">#{o.id.slice(0, 8)}</div>
                      <div className="text-sm mt-1">{o.name} <span className="text-[#a0aabf]">· {o.items?.length || 0} kalem</span></div>
                    </div>
                    <div className="text-right">
                      <div className="font-serif text-[#d4af37]">{new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(o.total || 0)}</div>
                      <div className="text-xs text-[#a0aabf] mt-1">{new Date(o.created_at).toLocaleDateString("tr-TR")}</div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between">
            <h2 className="wb-h3">Son Mesajlar</h2>
            <Link to="/admin/contacts" className="text-xs uppercase tracking-widest text-[#d4af37]">Tümü</Link>
          </div>
          <div className="mt-5 wb-card">
            {recentContacts.length === 0 ? (
              <div className="p-8 text-center text-sm text-[#a0aabf]">Henüz mesaj yok.</div>
            ) : (
              <ul className="divide-y divide-white/5">
                {recentContacts.map((m) => (
                  <li key={m.id} className="p-5 flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <div className="font-medium text-sm">{m.name} <span className="text-[#a0aabf]">· {m.email}</span></div>
                      <div className="text-xs text-[#d4af37] mt-1">{m.subject}</div>
                      <div className="text-xs text-[#a0aabf] mt-1 line-clamp-1">{m.message}</div>
                    </div>
                    <div className="text-xs text-[#a0aabf] whitespace-nowrap">{new Date(m.created_at).toLocaleDateString("tr-TR")}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
